import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const OuvidoriaConsultaRoute = props => {
  const { isOuvidoriaConsulta } = useContext(UserContext);

  if (isOuvidoriaConsulta) {
    return <Route {...props} />;
  } else if (!isOuvidoriaConsulta) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default OuvidoriaConsultaRoute;
